import React, { useState } from 'react'
import Cookies from 'js-cookie'
import { Card, Button, Form } from 'react-bootstrap'
import { useDispatch } from 'react-redux'
import configs from '../../config'
import Swal from 'sweetalert2'
import SlipData from './components/SlipData'

const Refund = () => {
  const [inputReadSlip, setInputReadSlip] = useState('')
  const [inputApproveRefund, setInputApproveRefund] = useState('')
  const [readSlipData, setReadSlipData] = useState(null)
  const [approvedData, setApprovedData] = useState(null)
  const [canRefund, setCanRefund] = useState(false)
  const [amount, setAmount] = useState('')

  const dispatch = useDispatch()

  const handleClickReadBarcode = async () => {
    if (!inputReadSlip) return

    try {
      dispatch({ type: 'loading_show' })
      const response = await fetch(`${configs.apiAdminGateway}/api/v1/admin/slip/refund?qrText=${inputReadSlip}`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${Cookies.get('accessToken')}`,
        },
      })

      const toJson = await response.json()

      if (toJson.status.code !== 0) {
        setReadSlipData(null)
        throw new Error(toJson.status.description)
      }

      setCanRefund(!toJson.data.slipTrx && !toJson.data.orderDetail)
      setReadSlipData(toJson.data)
      setAmount(toJson.data?.verifySlip?.amount)
      setInputApproveRefund(inputReadSlip)
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง',
        text: error.message,
        showCloseButton: true,
      })
    } finally {
      dispatch({ type: 'loading_hide' })
    }
  }

  const handleClickRefundSlip = async () => {
    if (!inputApproveRefund || !amount) {
      const title = !amount ? 'จำนวนเงิน' : !inputApproveRefund ? 'บาร์โค้ด' : 'ข้อมูล'

      Swal.fire({
        icon: 'error',
        title: `กรุณากรอก${title}`,
        showCloseButton: true,
      })
      return
    }

    try {
      dispatch({ type: 'loading_show' })
      const response = await fetch(`${configs.apiAdminGateway}/api/v1/admin/slip/refund`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${Cookies.get('accessToken')}`,
        },
        body: JSON.stringify({
          qrText: inputApproveRefund,
          amount: amount,
        }),
      })

      const toJson = await response.json()

      if (toJson.status.code !== 0) throw new Error(toJson.status.description)

      Swal.fire({
        icon: 'success',
        title: 'Refund สำเร็จ',
        showCloseButton: true,
      }).then(() => {
        handleReset()
      })
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง',
        text: error.message,
        showCloseButton: true,
      })
    } finally {
      dispatch({ type: 'loading_hide' })
    }
  }

  const handleReset = () => {
    setAmount('')
    setInputReadSlip('')
    setInputApproveRefund('')
    setReadSlipData(null)
    setApprovedData(null)
    setCanRefund(false)
  }

  return (
    <Card>
      <Card.Header>
        <h3>คืนเงิน</h3>
      </Card.Header>
      <Card.Body>
        <h4>สแกนเพื่อตรวจสอบบาร์โค้ด</h4>
        <div className="bg-warning p-5 rounded">
          <Form.Group>
            <Form.Control
              type="text"
              placeholder="ระบุ"
              value={inputReadSlip}
              onChange={(e) => setInputReadSlip(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  handleClickReadBarcode()
                }
              }}
            />
          </Form.Group>
          <Button
            variant="primary light w-100"
            onClick={() => {
              handleClickReadBarcode()
            }}
          >
            อ่านบาร์โค้ด
          </Button>
          {readSlipData && <SlipData data={readSlipData} />}
        </div>
        <br />
        {canRefund && (
          <div>
            <h4>สแกนเพื่ออนุมัติบาร์โค้ด</h4>
            <div className="bg-light p-5 rounded">
              <Form.Group>
                <Form.Control
                  type="text"
                  placeholder="กรอกจำนวนเงิน"
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                  className="mb-3 color-black"
                />
                <Form.Control
                  type="text"
                  placeholder="ระบุ"
                  value={inputApproveRefund}
                  onChange={(e) => setInputApproveRefund(e.target.value)}
                />
              </Form.Group>
              <div style={{ display: 'flex', width: '100%', gap: '8px' }}>
                <Button className="flex-grow-1" variant="danger" onClick={handleReset}>
                  ยกเลิก
                </Button>
                <Button className="flex-grow-1" variant="success" onClick={handleClickRefundSlip}>
                  คืนเงิน
                </Button>
              </div>
              {approvedData && (
                <>
                  <hr />
                  <h4>{approvedData?.description}</h4>
                </>
              )}
            </div>
          </div>
        )}
      </Card.Body>
    </Card>
  )
}

export default Refund
